export const companiesWorkspaceRateLimitsDataTable = "/companies/workspace_rate_limits_data_table";
// used in workspace rate limits data table endpoint selection
export const restUsersTrack = "0";
export const sdkV3Data = "1000";
